export const getRespErrorMessage = (error = null) => {
    const errorMessageDefault = 'Ошибка. Попробуйте еще раз';
    return error?.response?.data?.message || errorMessageDefault;
}